import PreviewSignatureService from '#services/preview/PreviewSignatureService';
import { parse } from 'url';

const inPreviewMode = (resolvedUrl: string) => {
  if (!resolvedUrl) {
    return false;
  }

  const { pathname: url, query } = parse(resolvedUrl, true);
  const { enable_preview_signature: signatureParams } = query ?? {};
  const enable_preview_signature = Array.isArray(signatureParams)
    ? signatureParams[0]
    : signatureParams;

  if (!enable_preview_signature) {
    return false;
  }

  try {
    const previewSignature = new PreviewSignatureService();
    previewSignature.checkSignature(url, enable_preview_signature);
  } catch (e) {
    return false;
  }

  return true;
};

export default inPreviewMode;
